export const mockVenuesList = {
    code: 0,
    data: {
        records: [
            { venueCode: 'V001', venueName: '體育中心A館', mchNo: 'M001' },
            { venueCode: 'V002', venueName: '體育中心B館', mchNo: 'M001' },
            { venueCode: 'V003', venueName: '體育中心C館', mchNo: 'M001' },
            { venueCode: 'V004', venueName: '訓練基地', mchNo: 'M001' },
            { venueCode: 'V005', venueName: '室內球場', mchNo: 'M001' },
        ],
        total: 5,
        pageSize: 999,
        pageNumber: 1
    },
    msg: 'success'
};

export const mockServiceAddResponse = {
    code: 0,
    data: null,
    msg: '提交完成'
};

export const mockServiceUpdateResponse = {
    code: 0,
    data: null,
    msg: '更新完成'
};

export const mockServiceDetailResponse = {
    code: 0,
    data: {
        id: 1,
        code: 'SMA1234567890',
        venueCode: '["V001","V002","V003"]',
        mchNo: 'M001',
        name: '測試產品',
        typeCode: 'COURSE',
        mainImage: 'https://example.com/image.jpg',
        status: 1,
        maxParticipants: 50,
        startTime: '2026-07-01',
        endTime: '2026-12-31',
        isPopular: false,
        isFeatured: true,
        extInfo: {
            organizer: '測試單位',
            syllabus: '測試大綱',
            description: '測試說明',
            reminder: '測試註意事項',
            activityImages: '[]',
            activityVideos: '[]',
            facilities: '["空調","wifi"]',
            outline: '測試內容描述',
            suitableAge: '18-60歲',
            genderRestrict: 0,
            unlimitedQuota: 50
        }
    },
    msg: 'success'
};

export const mockServiceListResponse = {
    code: 0,
    data: {
        records: [
            {
                id: 1,
                code: 'SMA1234567890',
                name: '測試產品',
                typeCode: 'COURSE',
                mainImage: 'https://example.com/image.jpg',
                status: 1,
                venueCodes: ['V001', 'V002'],
                venuesList: [
                    { venueCode: 'V001', venueName: '體育中心A館' },
                    { venueCode: 'V002', venueName: '體育中心B館' }
                ]
            }
        ],
        total: 1,
        pageSize: 10,
        pageNumber: 1
    },
    msg: 'success'
};
